/**
 * Tenant Context Middleware
 *
 * Runs after auth-middleware to set tenant context for authenticated users.
 * Sets the tenant context based on the request URL, ensuring all subsequent
 * middlewares and loaders have access to the correct tenant ID.
 *
 * This solves the race condition where window.location updates asynchronously
 * during navigation, but API requests need the tenant ID immediately.
 */

import { getTenantIdFromPathname } from "~/state/tenant";
import { setCurrentTenantId } from "./tenant-context";

export const tenantContextMiddleware = async ({
  request,
}: {
  request: Request;
}) => {
  const url = new URL(request.url);
  const tenantId = getTenantIdFromPathname(url.pathname);

  // Set the tenant context for this request
  // This value will be used by:
  // - API client headers (X-Tenant-ID)
  // - Tenant validation middleware
  // - All loaders and components
  setCurrentTenantId(tenantId);

  // Allow request to continue
  return null;
};
